function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#62D0FD;}\n\t.st1{fill:#FFFFFF;}\n  ");

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "scatter_badge_transparent");

var _ref4 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "scatter_badge_transparent"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  id: "Scatter",
  className: "st1",
  d: "M112.6,188.1c-3.5,0-6.4-0.4-8.7-1.2c-2.3-0.8-4.2-1.7-5.5-2.6c-1.4-1-2.3-1.9-2.8-2.8 c-0.5-0.9-0.8-1.5-0.8-1.8c0-1,0.2-2,0.6-3.1c0.4-1.1,1-2.1,1.6-3.1c0.6-1,1.3-1.8,2.1-2.4s1.4-1,2-1c0.8,0,1.4,0.5,1.9,1.5 l0.8,0.8c0.4,0.4,1,0.9,1.8,1.3s1.8,0.9,2.9,1.3c1.2,0.4,2.5,0.6,4.1,0.6c3.4,0,6.2-1,8.3-3.1c2.2-2.1,3.2-4.9,3.2-8.5 c0-2.5-0.6-4.7-1.7-6.7c-1.2-2-2.7-3.8-4.6-5.5s-4-3.3-6.5-4.9c-2.4-1.6-4.9-3.3-7.5-5s-5-3.6-7.5-5.6c-2.4-2-4.6-4.3-6.5-6.9 c-1.9-2.6-3.4-5.6-4.6-8.8c-1.2-3.3-1.7-7.1-1.7-11.3c0-3.6,0.6-7.3,1.9-11c1.2-3.7,3-7.2,5.1-10.6c2.2-3.3,4.8-6.5,7.7-9.4 c3-2.9,6.2-5.4,9.6-7.6c3.5-2.1,7.1-3.8,10.8-5.1c3.8-1.2,7.5-1.8,11.3-1.8c3.2,0,6.2,0.5,8.7,1.5c2.6,1,4.8,2.5,6.6,4.4 c1.8,1.9,3.2,4.1,4.1,6.8c1,2.6,1.5,5.6,1.5,8.8c0,3.1-0.5,6.1-1.6,9.1c-1.1,3-2.5,5.8-4.3,8.5c-1.8,2.7-3.8,5.1-6,7.4 c-2.2,2.3-4.5,4.2-6.9,5.9c-2.3,1.7-4.6,2.9-6.8,3.9c-2.2,0.9-4.2,1.4-5.8,1.4c-1.5,0-2.8-0.3-3.9-1s-2.1-1.5-2.9-2.5 s-1.4-2.1-1.8-3.2c-0.4-1.1-0.6-2.1-0.6-3c0-0.7,0.1-1.2,0.3-1.4c0.2-0.2,0.5-0.3,0.8-0.3c0.4,0,0.8,0.1,1.3,0.2 c0.5,0.1,1.2,0.2,1.9,0.2c2.3,0,4.8-0.8,7.5-2.4c2.8-1.6,5.3-3.6,7.8-6c2.4-2.4,4.5-5.1,6.1-8.1c1.6-2.9,2.5-5.8,2.5-8.6 c0-2.8-0.7-5.1-2.1-6.7c-1.4-1.6-3.7-2.4-7-2.4c-2.1,0-4.3,0.4-6.7,1.2c-2.4,0.8-4.8,1.9-7.2,3.3c-2.4,1.4-4.8,3.1-7,5.1 c-2.3,2-4.3,4.2-6,6.6c-1.7,2.4-3.1,5-4.2,7.8s-1.6,5.7-1.6,8.8c0,3.2,0.6,6.1,1.7,8.6c1.2,2.5,2.7,4.8,4.6,6.9 c1.9,2.1,4.1,4,6.5,5.7c2.4,1.7,4.9,3.5,7.5,5.2c2.5,1.7,5,3.5,7.5,5.3c2.4,1.8,4.6,3.8,6.5,6c1.9,2.2,3.5,4.6,4.6,7.3 s1.7,5.8,1.7,9.3c0,3.4-0.6,6.6-1.9,9.6c-1.3,3-3,5.6-5.2,7.9c-2.2,2.2-4.8,4-7.9,5.3S116.1,188.1,112.6,188.1z"
})));

var SvgScatterLogo = function SvgScatterLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240 240",
    style: {
      enableBackground: "new 0 0 240 240"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScatterLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scatter-logo.d83c3f25.svg";
export { ForwardRef as ReactComponent };